import Container from "react-bootstrap/Container";
import RetailLeadForm from "../../calculators/retailLeadForm";
import Button from "react-bootstrap/Button";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import "../../styles/sliderCalculator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useMemo, useState } from "react";

const ACCOUNTS = [
  {
    bank: "Kékpart Bank",
    maintenanceFee: "0 Ft/hó (min. 200 000 Ft jóváírással)",
    cardFee: "0 Ft/év",
    cashWithdrawal: "havi 2 díjmentes felvétel",
    netbankMobilbank: "Igen, azonnali utalással",
    studentDiscount: "Igen",
    annualEstimate: "~0 Ft",
    free: true,
    student: true,
  },
  {
    bank: "Napfény Takarék",
    maintenanceFee: "990 Ft/hó",
    cardFee: "3 500 Ft/év",
    cashWithdrawal: "havi 3 díjmentes felvétel",
    netbankMobilbank: "Igen",
    studentDiscount: "Nincs",
    annualEstimate: "~15 800 Ft",
    free: false,
    student: false,
  },
  {
    bank: "Zafír Bank",
    maintenanceFee: "1 490 Ft/hó",
    cardFee: "0 Ft/év",
    cashWithdrawal: "korlátlan, díjmentes",
    netbankMobilbank: "Igen, díjmentes azonnali utalás",
    studentDiscount: "Igen (50% kedvezmény)",
    annualEstimate: "~17 880 Ft",
    free: false,
    student: true,
  },
  {
    bank: "Régió Bank",
    maintenanceFee: "1 290 Ft/hó (diákoknak 0 Ft)",
    cardFee: "2 000 Ft/év",
    cashWithdrawal: "havi 2 díjmentes felvétel",
    netbankMobilbank: "Igen",
    studentDiscount: "Igen, teljesen díjmentes",
    annualEstimate: "~17 480 Ft / ~2 000 Ft diákként",
    free: false,
    student: true,
  },
  {
    bank: "DigiVáltó Bank",
    maintenanceFee: "0 Ft/hó",
    cardFee: "0 Ft (virtuális kártya); fizikai kártya 1 500 Ft egyszeri",
    cashWithdrawal: "havi 3 díjmentes felvétel",
    netbankMobilbank: "Igen, kizárólag mobilappban",
    studentDiscount: "Igen",
    annualEstimate: "~0-1 500 Ft",
    free: true,
    student: true,
  },
];

export default function LakossagiBankszamla() {
  const [onlyFree, setOnlyFree] = useState(false);
  const [onlyStudent, setOnlyStudent] = useState(false);

  const visible = useMemo(
    () =>
      ACCOUNTS.filter(
        (row) => (!onlyFree || row.free) && (!onlyStudent || row.student),
      ),
    [onlyFree, onlyStudent],
  );

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">
          LAKOSSÁGI BANKSZÁMLA • ÖSSZEHASONLÍTÁS • 2026
        </span>

        <h1 className="title">
          Lakossági bankszámla <br />
          <span style={{ color: "#c7d2fe" }}>összehasonlítás</span>
        </h1>

        <p className="subtitle">
          Magyarországon 2026-ban a lakossági bankszámlák havi számlavezetési
          díja jellemzően 0-1 990 forint között mozog; valóban ingyenes számlát
          elsősorban a digitális bankok és egyes hagyományos bankok kínálnak
          jövedelem-jóváírási feltétellel.
          <br />
          <span className="fw-bold">
            Hasonlítsd össze a díjakat, és találd meg a hozzád illő számlát!
          </span>
        </p>

        <div className="cta">
          <Button href="#compare" className="btn btn-primary">
            Összehasonlítás
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Ajánlatot kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">0-1 990 Ft</div>
                <div className="muted">Havi számlavezetési díj tartomány</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">5 bank</div>
                <div className="muted">Versenyeztetett pénzintézetek</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">15 nap</div>
                <div className="muted">
                  Számlaváltás automatikus átvezetéssel
                </div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="compare" className="section">
          <h2 className="h2">Bankszámlák díjai és funkciói egy táblázatban</h2>
          <p className="lead">
            Illusztratív, tájékoztató jellegű összehasonlítás — forrás: bankok
            hivatalos hirdetményei, 2026. július.
          </p>

          <div className="d-flex gap-4 flex-wrap mb-3">
            <Form.Check
              type="checkbox"
              id="filter-free"
              label="Csak ingyenes számlák"
              checked={onlyFree}
              onChange={(e) => setOnlyFree(e.target.checked)}
            />
            <Form.Check
              type="checkbox"
              id="filter-student"
              label="Csak diákbarát számlák"
              checked={onlyStudent}
              onChange={(e) => setOnlyStudent(e.target.checked)}
            />
          </div>
          <p className="small mb-3">
            {visible.length} számla felel meg a szűrésnek.
          </p>

          <Card className="card p-0 overflow-hidden">
            <Table responsive hover className="mb-0 align-middle retail-table">
              <thead>
                <tr>
                  <th>Bank</th>
                  <th>Számlavezetési díj</th>
                  <th>Kártyadíj</th>
                  <th>Készpénzfelvétel</th>
                  <th>Netbank / mobilbank</th>
                  <th>Diákkedvezmény</th>
                  <th className="text-end">Éves becsült költség</th>
                </tr>
              </thead>
              <tbody>
                {visible.map((row) => (
                  <tr key={row.bank}>
                    <th>{row.bank}</th>
                    <td>{row.maintenanceFee}</td>
                    <td>{row.cardFee}</td>
                    <td>{row.cashWithdrawal}</td>
                    <td>{row.netbankMobilbank}</td>
                    <td>{row.studentDiscount}</td>
                    <td className="text-end">
                      <strong>{row.annualEstimate}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </section>

        <section id="folyamat" className="section">
          <h2 className="h2">Így válts bankszámlát</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Számla kiválasztása</p>
                <p className="small">
                  A táblázat alapján megtalálod a díjszerkezetednek megfelelő
                  bankot
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Számlaváltás igénylése</p>
                <p className="small">
                  Vagy nyiss új számlát, és add meg a régi adatait az
                  áttöltéshez
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Utalások átvezetése</p>
                <p className="small">
                  Az új bank 15 munkanapon belül átviszi a rendszeres tételeket
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Régi számla zárása</p>
                <p className="small">
                  Az áttöltés után díjmentesen megszüntetheted a korábbi
                  számládat
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérjen ajánlatot még ma!</h2>
          <p className="lead small">
            Add meg az adataid, és segítünk kiválasztani a hozzád illő
            bankszámlát!
          </p>
          <Row>
            <Col md={4}>
              <RetailLeadForm leadType="retail_account" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes tanácsadás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több bank összehasonlítva egy helyen</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Segítség a számlaváltás lebonyolításában</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Bankfüggetlen ajánlások</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question:
                      "Létezik teljesen ingyenes bankszámla Magyarországon?",
                    answer:
                      "Igen, elsősorban a digitális bankoknál és néhány hagyományos banknál is találni havidíj-mentes számlát, gyakran jövedelem-jóváírási vagy minimális havi forgalmi feltétellel. Fontos a számlavezetési díjon túl a kártya-, utalási és készpénzfelvételi díjakat is megnézni, mert ott is keletkezhet rejtett költség.",
                  },
                  {
                    question:
                      "Mennyibe kerül egy átlagos lakossági bankszámla évente?",
                    answer:
                      "2026-ban egy átlagos, nem ingyenes lakossági bankszámla éves összköltsége (számlavezetés, kártyadíj, néhány utalás és készpénzfelvétel) jellemzően 15 000-20 000 forint között alakul, de ez a tényleges használattól és a választott banktól függően jelentősen eltérhet.",
                  },
                  {
                    question: "Hogyan működik a számlaváltási szolgáltatás?",
                    answer:
                      "A számlaváltási szolgáltatás keretében az új bankod 15 munkanapon belül automatikusan átveszi a régi számládhoz kötött rendszeres átutalásokat és beszedéseket a te meghatalmazásod alapján, így nem kell egyenként átírnod őket. A régi számlát ezután díjmentesen zárhatod le.",
                  },
                  {
                    question:
                      "Milyen kedvezményeket kapnak a diákok bankszámlanyitáskor?",
                    answer:
                      "A diákszámlák jellemzően díjmentes vagy jelentősen csökkentett számlavezetési díjat, ingyenes bankkártyát és kedvezményes vagy díjmentes készpénzfelvételt kínálnak, felsőoktatási hallgatói vagy életkor szerinti (jellemzően 25-35 év alatti) jogosultsághoz kötve, banktól függő pontos feltételekkel.",
                  },
                  {
                    question:
                      "Mire figyeljek a netbank és mobilbank összehasonlításakor?",
                    answer:
                      "Érdemes megnézni, hogy az azonnali utalás díjmentes-e az alkalmazásban, van-e beépített költségkövetés és kategorizálás, és mennyire egyszerű benne a kártyaletiltás vagy limitmódosítás. A biztonsági funkciók (kétfaktoros azonosítás, push-értesítés minden tranzakcióról) szintén kulcsfontosságúak.",
                  },
                ],
              },
            ]}
          />

          <p className="small mt-4">
            A táblázatban feltüntetett bankok és díjak illusztratív, tájékoztató
            célt szolgálnak; a végleges, hatályos díjakat és feltételeket mindig
            az adott bank hivatalos kondíciós listája tartalmazza. A
            Financials.hu nem hitelintézet, számlavezetést nem végez.
          </p>
        </section>
      </Container>
    </>
  );
}
